import { DarwinFlex, DarwinInput } from 'components/darwin-ui';
import style from './RoleDetail.module.css';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect } from 'react';

interface RoleDetailsProps {
  name: string | undefined;
  description: string | undefined;
  readonly?: boolean;
  onChange?: (
    values: { name: string; description: string },
    isValid: boolean
  ) => void;
}

export const RoleDetails = ({
  name,
  description,
  readonly = false,
  onChange,
}: RoleDetailsProps) => {
  const { t } = useTranslation();

  const [form] = Form.useForm();

  useEffect(() => {
    if (name !== undefined && description !== undefined) {
      form.setFieldsValue({ 'role-name': name, roleDescription: description });
    }
  }, [name, description, form]);

  const handleValuesChange = useCallback(
    async (
      _: any,
      allValues: { 'role-name': string; roleDescription: string }
    ) => {
      if (onChange) {
        try {
          await form.validateFields();
          onChange(
            {
              name: allValues['role-name'],
              description: allValues.roleDescription,
            },
            true
          );
        } catch (error: any) {
          onChange(
            {
              name: allValues['role-name'],
              description: allValues.roleDescription,
            },
            error.errorFields.length === 0
          );
        }
      }
    },
    [form, onChange]
  );

  return (
    <>
      <DarwinFlex vertical className={style.cardContainer}>
        <DarwinFlex vertical>
          <Form
            form={form}
            layout="vertical"
            style={{ marginTop: '20px' }}
            onValuesChange={handleValuesChange}
          >
            <Form.Item
              label={t('roles.wizard-sections.role-details.role-name-label')}
              name="role-name"
              rules={[
                {
                  required: true,
                  message: t(
                    'roles.wizard-sections.role-details.role-name-required'
                  ),
                },
              ]}
            >
              <DarwinInput
                placeholder={t(
                  'roles.wizard-sections.role-details.role-name-placeholder'
                )}
                disabled={readonly}
              />
            </Form.Item>
            <Form.Item
              label={t(
                'roles.wizard-sections.role-details.role-description-label'
              )}
              name="roleDescription"
              initialValue={t(
                'roles.wizard-sections.role-details.role-description'
              )}
            >
              <Input.TextArea
                maxLength={300}
                autoSize={{ minRows: 5 }}
                disabled={readonly}
              />
            </Form.Item>
          </Form>
        </DarwinFlex>
      </DarwinFlex>
    </>
  );
};
